module.exports = __webpack_public_path__ + "static/homepage-d5a4b9339a1ec53809f0cb600b141c44.png";